import {Component} from 'san';

import styles from './style/index.module.less';

import RelateNews from './components/relateNews';
import RecentArticle from './components/recentArticle';

export default class Relate extends Component {
    static template = require('./index.html');
    static components = {
        'ui-relate-news': RelateNews,
        'ui-recent-article': RecentArticle
    };
    static computed = {
        relateNews() {
            const data = this.data.get('data') || [];
            return data.find(item => item.itemType === 'relatedNews');
        },
        showRelateNews() {
            const data = this.data.get('relateNews.itemData');
            return Array.isArray(data) && data.length > 0;
        },
        recentArticle() {
            const data = this.data.get('data') || [];
            return data.find(item => item.itemType === 'recentArticle');
        },
        showRecentArticle() {
            const data = this.data.get('recentArticle.itemData');
            const isBjh = this.data.get('common.isBjh');
            return isBjh && Array.isArray(data) && data.length > 0;
        }
    };
    initData() {
        return {
            styles
        };
    }
};
